import Button from 'components/Button';
import ActionModal from 'components/Modal/ActionModal';
import Space from 'components/Space';
import { FC, useContext, useState } from 'react';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { ReviewPageContext } from '.';
import { ButtonsContainer, Container } from './components';
import NoAnswer from './NoAnswer';

type Loading = Record<'refuse' | 'accept', boolean>;
const initialLoading: Loading = {
  refuse: false,
  accept: false,
};

const WaitingMentee: FC = () => {
  const { interview } = useContext(ReviewPageContext);

  const dateDifference = interview?.date
    ? new Date().getTime() - new Date(interview?.date).getTime()
    : undefined;

  return dateDifference && dateDifference < 0 ? (
    <WaitingMenteeBeforeDate />
  ) : (
    <NoAnswer />
  );
};

const WaitingMenteeBeforeDate: FC = () => {
  const { interview } = useContext(ReviewPageContext);
  const currentMenteeId = interview?.mentorship?.menteeId;
  const isAuthor = String(interview?.authorId) === String(currentMenteeId);
  const [loading, setLoading] = useState<Loading>(initialLoading);
  const [error, setError] = useState<boolean>(false);
  const [refuseOpen, setRefuseOpen] = useState<boolean>(false);

  const handleAccept = async () => {
    setLoading({ ...initialLoading, accept: true });
    try {
      await privateAPI.post(`/interview/mentee-accept/${interview?.id}`);
      mutate(`/interview/${interview?.id}`);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(initialLoading);
    }
  };

  const handleRefuse = async () => {
    setLoading({ ...initialLoading, refuse: true });
    try {
      await privateAPI.post(`/interview/mentee-refuse/${interview?.id}`);
      mutate(`/interview/${interview?.id}`);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(initialLoading);
      setRefuseOpen(false);
    }
  };
return (
    <Container>
      {error && <p style={{ color: 'red' }}>Une erreur est survenue.</p>}
      {/* LOGIQUE : 
          - Si le mentoré est l'auteur : il attend le mentor (pas de boutons).
          - Si le mentoré n'est pas l'auteur : il doit accepter/refuser la proposition du mentor.
      */}
      {isAuthor ? (
        <p style={{ color: 'var(--primary-700)', fontStyle: 'italic', marginTop: '1.5rem' }}>
          Votre proposition d'entretien a bien été envoyée. 
          Elle est en attente de validation par votre mentor.
        </p>
      ) : (
        <>
          <p>Souhaitez-vous accepter cette proposition d'entretien ?</p>
          <Space height={1} />
          <ButtonsContainer>
            <Button variant="outlined" onClick={() => setRefuseOpen(true)}>
              Refuser
            </Button>
            <Button color="primary" onClick={handleAccept} loading={loading.accept}>
              Accepter l'entretien
            </Button>
          </ButtonsContainer>
        </>
      )}

      {/* Modale de refus */}
      <ActionModal
        open={refuseOpen}
        close={() => setRefuseOpen(false)}
        title="Refuser l'entretien"
        applyText="Refuser"
        apply={handleRefuse}
        cancel={() => setRefuseOpen(false)}
      >
        <p>Êtes-vous sûr de vouloir refuser cet entretien ?</p>
      </ActionModal>
    </Container>
  );
};

export default WaitingMentee;